// extracted by mini-css-extract-plugin
module.exports = {"linksWrapper":"Receipt_linksWrapper__pKeFT","link":"Receipt_link__fD09K"};